/**
 * The analytics function takes a variable number of dataLayer blocks as arguments.
 *
 * ```ts
 * analytics({
 *   event: 'content_viewed',
 *   team: 'control',
 *   properties: {
 *     content_type: 'home',
 *     content_level1: 'home'
 *   }
 * })
 * ```
 * @param blocks at least one dataLayer block
 */
export default function analytics(...blocks) {
    window.dataLayer = window.dataLayer || [];
    for (let i = 0, l = blocks.length; i < l; i++) {
        window.dataLayer.push({ event: '_clear', properties: null }, blocks[i]);
    }
}
